import React from 'react'

import infoIcon from '../../assets/img/info-disclaimer.png'

const Disclaimer = ({ mensajeConmebol }) => {
  if (!mensajeConmebol) return null

  return (
    <div className='disclaimer active gray partidos'>
        <img src={infoIcon} alt='información'/>
        <div dangerouslySetInnerHTML={{ __html: mensajeConmebol }} />
    </div>
  )
}

export default Disclaimer
